import { render, staticRenderFns } from "./VisitTable.vue?vue&type=template&id=475282bb&scoped=true&"
import script from "./VisitTable.vue?vue&type=script&lang=js&"
export * from "./VisitTable.vue?vue&type=script&lang=js&"
import style0 from "./VisitTable.vue?vue&type=style&index=0&id=475282bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475282bb",
  null
  
)

export default component.exports